import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix marker icons for leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
    shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const LeafletMap = ({ latitudes, longitudes }) => {
    // Filter valid coordinates
    const validCoordinates = latitudes
        .map((lat, index) => ({
            lat,
            lng: longitudes[index],
        }))
        .filter(coord => typeof coord.lat === "number" && typeof coord.lng === "number");

    // Use the first valid coordinate as the map center or fallback to a default.
    const center =
        validCoordinates.length > 0
            ? [validCoordinates[0].lat, validCoordinates[0].lng]
            : [0, 0];

    // If no valid coordinates, show a message or an empty map
    if (validCoordinates.length === 0) {
        return <p className="flex text-[10px]">No valid coordinates to display.</p>;
    }

    return (
        <MapContainer center={center} zoom={10} style={{ height: "177px", width: "100%" }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            {validCoordinates.map((coord, index) => (
                <Marker key={index} position={[coord.lat, coord.lng]}>
                    <Popup>
                        Location: {coord.lat}, {coord.lng}
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
};

export default LeafletMap;
